
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import InputRadio from '@/components/InputRadio.vue';
import IdDocType from '@/resources/enum/IdDocType';

@Component({
  components: {
    InputRadio
  }
})
export default class TopContentSelect extends Vue {
  @Prop({ type: Array, required: true })
  public list!: {
    key: IdDocType;
    text: string;
  }[];

  @Prop({ type: Number, required: true })
  public value!: IdDocType;

  @Emit()
  public input(value: IdDocType) {}
}
